/*
 * @Author: zhushitao
 * @Date: 2021-03-10 14:17:15
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-11-05 17:14:59
 * @Description: 缓存
 */
import fromentries from 'fromentries';

import { is } from '../utils/index';

const store = new Map();

export default {
  set(key: any, value: any) {
    return store.set(key, value);
  },
  get(key: any) {
    return store.get(key);
  },
  getAll() {
    return store;
  },
  getMap() {
    const entries = fromentries(store);
    return entries;
  },
  put(data: any) {
    if (is.object(data)) {
      const entries = Object.entries(data);

      entries.forEach(([k, v]) => {
        store.set(k, v);
      });

      return entries.length;
    } else if (is.map(data)) {
      [...data.entries()].forEach(([k, v]: [any, any]) => {
        store.set(k, v);
      });

      return data.size;
    }

    return false;
  },
  has(key: any) {
    return store.has(key);
  },
  delete(key: any) {
    return store.delete(key);
  },
  clear() {
    return store.clear();
  },
};
